import { media, styled } from '@styles';

export const Wrapper = styled.div`
  width: 52vw;
  max-width: 1000px;
  margin: 0 auto;
  padding: 50px;
  border-top: 1px solid #e6e9ea;
  border-bottom: 1px solid #e6e9ea;
  position: relative;

  ${media.largeScreen`
    width: 57vw;
    max-width: 720px;
    padding: 40px 50px;
  `}
  ${media.mediumScreen`
    max-width: 640px;
    width: 85vw;
  `}
  ${media.smallScreen`
    padding: 24px 0 24px 39px;
  `}

  img {
    position: absolute;
    left: 0;
    top: 58px;
    width: 21px;

    ${media.largeScreen`
      top: 50px;
      width: 18px;
    `}
    ${media.smallScreen`
      top: 33px;
    `}
  }

  p {
    font-family: ${(props) => props.theme.typography.extraFontFamily};
    font-size: ${(props) => props.theme.typography.baseFontSize};
    font-family: 'Inter';
    font-weight: 500;
    line-height: 180%;
  }
`;
